import { InferType, object, string } from "yup";
import { CharacterLimitExceeded } from "constants/text";

export const COMMENT_MAX_LENGTH = 500;

export const commentFormSchema = object({
	commentText: string().max(COMMENT_MAX_LENGTH, CharacterLimitExceeded).trim()
});

export type CommentFormFields = InferType<typeof commentFormSchema>;
